
import { Component, Inject, Prop, Vue } from 'vue-property-decorator'

@Component({})
export default class FillGridMapAsideTaskList extends Vue {
  @Prop({ required: true, default: () => [] })
  tasks: any[]

  @Prop({ required: true })
  ident: string

  @Prop({ required: false, default: '' })
  icon: string

  @Prop({ required: false, default: 'black' })
  iconColor: string

  @Prop({ required: true, default: 'Tareas' })
  title: string

  @Prop({ required: false, default: -1 })
  selectedTaskId: number

  @Prop({ required: false, default: false })
  collapsed: boolean

  @Inject() readonly openFillInTypistFromMap: Function

  isCollapsed: boolean = false

  created () {
    this.isCollapsed = this.collapsed
  }

  openTypist (task: any) {
    this.openFillInTypistFromMap(task)
  }
}

